module.exports = __webpack_public_path__ + "static/media/iconfinder_React.js_logo_1174949.f0793d9f.svg";